module.exports = __webpack_public_path__ + "static/imageEditor@2x-8d214792346728e495aea713d39c58a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/imageEditor@2x.png
// module id = 1091
// module chunks = 168707334958949